module.exports = __webpack_public_path__ + "img/product_17.61e9777.jpg";